import { render, staticRenderFns } from "./resRs.vue?vue&type=template&id=524a70be&"
import script from "./resRs.vue?vue&type=script&lang=js&"
export * from "./resRs.vue?vue&type=script&lang=js&"
import style0 from "./resRs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports